export default __webpack_public_path__ + "static/media/surfer.ba7c4590.png";